// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"21cccc53","821":"7996d920"}[chunkId] + ".chunk.js";
};